const getters = {
    DEMO_wellName: state => state.DEMO.wellName
}

export default getters